document.addEventListener('DOMContentLoaded', function() {
    // Function to get the canonical URL
    function getCanonicalUrl() {
        var links = document.getElementsByTagName('link');
        for (var i = 0; i < links.length; i++) {
            if (links[i].getAttribute('rel') === 'canonical') {
                return links[i].getAttribute('href');
            }
        }
        return null;
    }

    // Function to perform the redirect
    function redirectToCanonical() {
        var canonicalUrl = getCanonicalUrl();
        var currentUrl = window.location.href;

        // Use sessionStorage to check if a redirect has already happened
        if (canonicalUrl && currentUrl !== canonicalUrl && !sessionStorage.getItem('redirected')) {
            sessionStorage.setItem('redirected', 'true');
            window.location.replace(canonicalUrl);
        }
    }

    // Call the redirect function
    redirectToCanonical();
});
